import clsx from 'clsx'
import React, {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
    //toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
    toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'
//toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    return (
        <div className='d-flex align-items-stretch flex-shrink-0'>
            <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
                <div className='d-flex flex-column text-end'>
                    {user.firstname} {user.lastname}<span className='text-muted'>{user.role}</span>
                </div>
                <div className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}>
                    <img src={toAbsoluteUrl('/media/icons/duotune/general/gen022.svg')} alt='profil-pic' />
                </div>
            </div>
        </div>
    )
}

export {Topbar}
